<template>
  <v-container fluid style="padding-right:0px; padding-bottom:0px">
    <v-row>
    <v-col cols="12">
      <h1>Configure Audiences
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
          </template>
          <span>How would you like to segment your audience files?</span>
        </v-tooltip>
      </h1>
    </v-col>
    </v-row>

      <div class="hot">
        <hot-table :data="cleanData" :settings="hotSettings" ref="hotTableComponent" id="audiences-config-table"/>
      </div>

      <audiences-bottom-helpers :data="cleanData" :hotRef="hotRef" />
  </v-container>
</template>

<script>
  import { HotTable } from '@handsontable/vue'
  // eslint-disable-next-line no-unused-vars
  import Handsontable from 'handsontable'
  import AudiencesBottomHelpers from './AudiencesBottomHelpers'

  export default {
    name: 'AudienceConfig',
    components: {
      HotTable,
      AudiencesBottomHelpers
    },
    data () {
      return {
        cleanData: [

          {
            "split_name": "Acquisition source",
            "split_type": "category",
            "column_heading": "crm.acquisition_source"
          },
          {
            "split_name": "Total donations ($)",
            "split_type": "float",
            "split_buckets": "0-199,200-499,500-999,1000-4999,5000-9999",
            "column_heading": "crm.total_donations_usd"
          },
          {
            "split_name": "Last donation ($)",
            "split_type": "float",
            "split_buckets": "0-99,100-199,200-499,500-999,1000-4999",
            "column_heading": "crm.last_donation_usd"
          },
          {
            "split_name": "Last donation date",
            "split_type": "date",
            "split_buckets": "",
            "column_heading": "crm.last_donation_date"
          },
          {
            "split_name": "Churn Risk",
            "split_type": "float",
            "split_buckets": "0-100,4",
            "column_heading": "crm.churn_risk"
          },
          {
            "split_name": "Race",
            "split_type": "category",
            "split_buckets": "",
            "column_heading": "vb.voterbase_race"
          },
          {
            "split_name": "Party Registration",
            "split_type": "category",
            "split_buckets": "Democrat,Unaffiliated",
            "column_heading": "vb.vf_party"
          },
          {
            "split_name": "Ideology (L=100)",
            "split_type": "float",
            "split_buckets": "0-100,4",
            "column_heading": "ts.tsmart_partisan_score"
          }
        ],
        hotSettings: {
          licenseKey: 'non-commercial-and-evaluation',
          colHeaders: ['Name', 'Type', 'Buckets', 'File Column'],
          columns: [
            {data: 'split_name'},
            {data: 'split_type',
              type: 'autocomplete',
              strict: true,
              source: ['category', 'date', 'float']
            },
            {data: 'split_buckets'},
            {data: 'column_heading'}
          ],
          rowHeaders: false,
          width: '100%',
          stretchH: 'all',
          // height: 560,
          rowHeights: 50,
          // colWidths: 90,
          // fixedColumnsLeft: 2,
          // cells: function (row, col) {
          //   var cellProperties = {}
          //
          //   if (col === 1) {
          //     cellProperties.colWidths = 200
          //   // } else if (col === 1) {
          //   //   cellProperties.colWidths = 150
          //   // } else if (col === 2) {
          //   //   cellProperties.colWidths = 200
          //   }
          //
          //   return cellProperties
          // },
          // dropdownMenu: ['filter_by_value', 'filter_action_bar'],
          // filters: true,
          headerTooltips: {
            columns: true,
            onlyTrimmed: true
          },
          hiddenColumns: {
            indicators: true
          },
          contextMenu: ['row_above', 'row_below', 'remove_row'],
          outsideClickDeselects: false
        },
        hotRef: {}
        // id: 'my-custom-id',
        // className: 'my-custom-classname',
        // style: 'width: 300px; height: 142px; overflow: hidden; border: 1px solid red;'
      }
    },
    computed: {
      // cleanData () {
      //   return normalizeAdSetData(this.adSetData)
      // }
    },
    methods: {
    },
    mounted () {
      this.hotRef = this.$refs.hotTableComponent.hotInstance
    }
  }
</script>
<style>

    /* Specific column (B) */
    #audiences-config-table .ht_master tr > td:nth-child(1) {
      font-weight: bold;
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
